import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

// Initialize after DOM is ready
const app = createApp(App).use(store).use(router as any)

app.mount('#app')

// Initialize jQuery plugins after Vue app is mounted
declare global {
  interface Window {
    jQuery: any
    $: any
    WOW: any
    counterUp: any
  }
}

// Wait for jQuery and plugins to load
const initPlugins = () => {
  if (typeof window !== 'undefined' && window.$ && window.WOW) {
    // Initialize WOW.js
    new window.WOW().init()

    // Sticky Navbar
    window.$(window).scroll(function (this: Window) {
      if (window.$(this).scrollTop() > 90) {
        window.$('.nav-bar').addClass('fixed-top').css('padding', '0')
      } else {
        window.$('.nav-bar').removeClass('fixed-top').css('padding', '0px 90px')
      }
    })

    // Header carousel
    if (window.$('.header-carousel').length) {
      window.$('.header-carousel').owlCarousel({
        animateOut: 'rotateOutUpRight',
        animateIn: 'rotateInDownLeft',
        items: 1,
        autoplay: true,
        smartSpeed: 1000,
        dots: false,
        loop: true,
        nav: true,
        navText: [
          '<i class="bi bi-chevron-left"></i>',
          '<i class="bi bi-chevron-right"></i>'
        ]
      })
    }

    // Testimonials carousel
    if (window.$('.testimonial-carousel').length) {
      window.$('.testimonial-carousel').owlCarousel({
        items: 1,
        autoplay: true,
        smartSpeed: 1000,
        animateIn: 'fadeIn',
        animateOut: 'fadeOut',
        dots: false,
        loop: true,
        nav: true,
        navText: [
          '<i class="bi bi-chevron-left"></i>',
          '<i class="bi bi-chevron-right"></i>'
        ]
      })
    }

    // Facts counter
    if (window.$('[data-toggle="counter-up"]').length && window.counterUp) {
      window.$('[data-toggle="counter-up"]').counterUp({
        delay: 10,
        time: 2000
      })
    }

    // Donation progress
    if (window.$('.donation-item .donation-progress').length) {
      window.$('.donation-item .donation-progress').waypoint(function () {
        window.$('.donation-item .progress .progress-bar').each(function (this: HTMLElement) {
          window.$(this).css('height', window.$(this).attr('aria-valuenow') + '%')
        })
      }, { offset: '80%' })
    }
  } else {
    // Retry if libraries haven't loaded yet
    setTimeout(initPlugins, 100)
  }
}

// Initialize plugins when DOM is ready
if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPlugins)
  } else {
    // DOM is already ready
    setTimeout(initPlugins, 500)
  }
}
